<template>
  <a-card :bordered='false'>
    <div class="p-b-25 s_bf">
      <a-form ref='form' :model='search' class="m-b-35" :initialValues="search" :onFinish='pageSearchChange'
        layout='inline'>
        <a-form-item>
          <a-radio-group button-style="solid" @change="onChangeRadio" v-model:value="search.day_type">
            <a-radio-button :value="1">7天</a-radio-button>
            <a-radio-button :value="2">30天</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="">
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD'
            :disabled-date="disabledDate" @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-spin :spinning="listLoading">
        <!-- <div class="m-b-35" ref="charts" style="width:100%;height:600px"></div> -->
        <echartLine :echartsData='echartData' v-if='!listLoading'></echartLine>
      </a-spin>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='date' :columns='columns' :data-source='data'>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
        :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
        @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
    </div>
  </a-card>
</template>

<script>
  import moment from "moment";
  import { reactive, toRefs, onMounted, ref } from 'vue';
  import { giftAnalysis } from "@/api/integralShop";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  export default {
    props: {},
    setup(props) {
      var charts = ref();
      let data = ref([]);
      const search = ref({
        start_time: "",
        end_time: "",
        day_type: 1,
        page: 1,
        limit: 10,
        
      });
      const state = reactive({
        listLoading: true,
        total: 1,
        time: [],
        echartData: {
          dataName: ['积分订单', '礼品兑换量','消耗积分','消耗金额'],
          latelyDays: [],
          series: []
        },
      });
      let columns = [
        {
          title: "日期",
          dataIndex: "date",
          key: "date",
        },
        {
          title: '积分订单',
          dataIndex: "order_count",
          key: "order_count",
        },
        {
          title: '礼品兑换数量',
          dataIndex: "gift_count",
          key: "gift_count",
        },
        {
          title: "消耗积分",
          dataIndex: "pay_point_count",
          key: "pay_point_count",
        },
        {
          title: "消耗金额",
          dataIndex: "pay_price_count",
          key: "pay_price_count",
        }
      ];
      // 页面筛选项搜索
      const pageSearchChange = async () => {
        search.value = { ...search.value, page: 1 };
        initData();
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData();
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData();
      };
      function getDaysBetween(dateString1, dateString2) {
        var startDate = Date.parse(dateString1);
        var endDate = Date.parse(dateString2);
        var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
        return days;
      }
      const disabledDate = (current) => {
        return current && current >= moment(new Date() - 86400000).endOf("day");
      };
      // 7天/30天筛选
      const onChangeRadio = () => {
        search.value.start_time = "";
        search.value.end_time = "";
        state.time = [];
      };
      //日期筛选
      const onChange = (e) => {
        if (!e.length) {
          search.value.start_time = "";
          search.value.end_time = "";
          state.time = [];
          search.value.day_type = 1;
          return false;
        }
        var day_num = getDaysBetween(e[0], e[1]) + 1;
        if (day_num < 3) {
          message.error("选择时间范围不得小于3天，建议选择时间范围为7天");
          search.value.start_time = "";
          search.value.end_time = "";
          state.time = [];
        } else {
          search.value.start_time = e[0];
          search.value.end_time = e[1];
          search.value.day_type = 0
        }
      };
      const initData = async () => {
        state.listLoading = true
        let result = await giftAnalysis(search.value).then(res => res.data).catch(error => error)
        state.listLoading = false
        if (iscode(result)) {
          data.value = result.data.lineList.data
          state.total = result.data.lineList.total;
          // 组合成 图表
          var pay_point_count = [],
            date = [],
            pay_price_count = [],
            order_count = [],
            gift_count = []

          result.data.totalList.map(v => {
            date.push(v.date)
            pay_point_count.push(v.pay_point_count)
            pay_price_count.push(v.pay_price_count)
            order_count.push(v.order_count)
            gift_count.push(v.gift_count)
          })
          state.echartData.latelyDays = date
          state.echartData.series = [
            {
              name: '积分订单',
              type: 'line',
              data: order_count,
              smooth: true
            },
            {
              name: '礼品兑换量',
              type: 'line',
              data: gift_count,
              smooth: true
            },
            {
              name: '消耗积分',
              type: 'line',
              data: pay_point_count,
              smooth: true
            },
            {
              name: '消耗金额',
              type: 'line',
              data: pay_price_count,
              smooth: true
            }
          ]

        }

      }
      onMounted(() => {
        initData();
      });
      return {
        charts,
        search,
        ...toRefs(state),
        data,
        columns,
        onChange,
        onChangeRadio,
        pageSearchChange,
        pageSizeChange,
        pageCurrentChange,
        disabledDate
      };
    },
  };
</script>